import React from 'react';

/**
 * Format the short_description for the products models
 * @param {array} strings - array containing the product description lines
 */
export default function formatProductShortDescription(strings) {
    const isLastString = index => index === strings.length - 1;

    return strings.map((string, i) => isLastString(i) ? string : [string, <br key="br"/>]);
}



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/util/react/format-product-short-description.js